import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["value", "disabled"]

import Filter from '@/core/components/resource/Filter';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';

interface ResourceFilterProps {
	filter: Filter;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceFilter',
  props: {
    filter: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppFormGroup, {
    id: __props.filter.id,
    label: __props.filter.label
  }, {
    default: _withCtx(() => [
      (__props.filter.type === 'select')
        ? (_openBlock(), _createBlock(AppSelect, {
            key: 0,
            id: __props.filter.id,
            "model-value": __props.filter.value.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (__props.filter.setValue($event)))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filter.options.value, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.value,
                  value: option.value,
                  disabled: option.disabled
                }, _toDisplayString(option.label), 9, _hoisted_1))
              }), 128))
            ]),
            _: 1
          }, 8, ["id", "model-value"]))
        : (_openBlock(), _createBlock(AppInput, {
            key: 1,
            type: __props.filter.type,
            id: __props.filter.id,
            "model-value": __props.filter.value.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (__props.filter.setValue($event)))
          }, null, 8, ["type", "id", "model-value"]))
    ]),
    _: 1
  }, 8, ["id", "label"]))
}
}

})